import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ApplicationNotificationSeverity;
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbWebServices } from "abweb/service/AbWebServices";

/**
 * A helper constant indicating the severity/importance of an Notification.  Instances of this
 * class should generally not be constructed ad hoc; instead the predefined constants should be used.
 */
export class ApplicationNotificationSeverity {
  constructor(priority, name, iconName) {
    /**
     * Relative importance.  Higher numbers are more important
     */
    _defineProperty(this, "_priority", void 0);
    /**
     * A text name
     */
    _defineProperty(this, "_name", void 0);
    /**
     * The name of the icon to display for notifications of this severity
     */
    _defineProperty(this, "_iconName", void 0);
    this._priority = priority;
    this._name = name;
    this._iconName = iconName;
  }

  /**
   * The localized label to display for this severity's name
   */
  get label() {
    return AbWebServices.i18n.getMessage("abweb", `notification.severity.${this.name.toLowerCase()}`);
  }

  /**
   * Relative importance.  Higher numbers are more important
   */
  get priority() {
    return this._priority;
  }

  /**
   * A text name
   */
  get name() {
    return this._name;
  }

  /**
   * The name of the icon to display for notifications of this severity
   */
  get iconName() {
    return this._iconName;
  }
  toString() {
    return this.name;
  }

  /**
   * Compares two ApplicationNotificationSeverity objects using their priorities.  Higher priority is greater
   * than lower priority.
   *
   * @param a   severity 1
   * @param b   severity 2
   * @return    standard comparison value
   *
   */
  static compare(a, b) {
    return a.priority - b.priority;
  }
}
_ApplicationNotificationSeverity = ApplicationNotificationSeverity;
_defineProperty(ApplicationNotificationSeverity, "ERROR", new _ApplicationNotificationSeverity(1000, "ERROR", "ab:notificationError"));
_defineProperty(ApplicationNotificationSeverity, "WARNING", new _ApplicationNotificationSeverity(100, "WARNING", "ab:notificationWarning"));
_defineProperty(ApplicationNotificationSeverity, "INFO", new _ApplicationNotificationSeverity(10, "INFO", "ab:notificationInfo"));
_defineProperty(ApplicationNotificationSeverity, "UNSEEN", new _ApplicationNotificationSeverity(10, "UNSEEN", "ab:notificationInfo"));
//# sourceMappingURL=ApplicationNotificationSeverity.js.map
